/**
 * Long-form help for Opportunity scope assessment fields (`FormInfoHelpModal`).
 */
export const OPPORTUNITY_SCOPE_FIELD_INFO = {
  oppSiteAddress: {
    title: 'Site address',
    bullets: [
      'Physical location for site assessment; may match the address captured on the opportunity step.',
    ],
  },
} as const;

export type OpportunityScopeInfoKey = keyof typeof OPPORTUNITY_SCOPE_FIELD_INFO;

export function opportunityScopeInfoA11y(
  key: OpportunityScopeInfoKey,
): { description: string; hint: string } {
  const p = OPPORTUNITY_SCOPE_FIELD_INFO[key];
  return {
    description: `${p.title}. ${p.bullets.join(' ')}`,
    hint: 'Opens help in a dialog.',
  };
}
